import React from 'react';
import { 
  Music, 
  Trophy, 
  Theater, 
  Users, 
  Sparkles, 
  PartyPopper, 
  Umbrella, 
  Martini, 
  Calendar, 
  Ticket 
} from 'lucide-react';

interface CategoryIconProps {
  category: string;
  size?: number;
  className?: string;
}

const CategoryIcon: React.FC<CategoryIconProps> = ({ 
  category, 
  size = 24, 
  className = '' 
}) => {
  // Map category to icon
  switch (category.toLowerCase()) {
    case 'concert':
    case 'shows':
      return <Music size={size} className={className} />;
    case 'sports':
    case 'esportes':
      return <Trophy size={size} className={className} />;
    case 'theater':
    case 'teatro':
      return <Theater size={size} className={className} />;
    case 'conference':
    case 'conferencia':
      return <Users size={size} className={className} />;
    case 'festival':
    case 'festivais':
      return <Sparkles size={size} className={className} />;
    case 'carnaval':
      return <PartyPopper size={size} className={className} />;
    case 'reveillon':
      return <Calendar size={size} className={className} />;
    case 'happy hour':
      return <Martini size={size} className={className} />;
    case 'festas':
      return <PartyPopper size={size} className={className} />;
    default:
      return <Ticket size={size} className={className} />;
  }
};

export default CategoryIcon;